import { getDynamicVariable } from "config/dynamicVariables";
import type { LanguageCode } from "config/languages";
import type { StoryblokTemplateProps } from "types/storyblok";
import replaceAll from "utils/replaceAll";

export const getReplacers = (language: LanguageCode) => ({
  "{{compensation_value}}": getDynamicVariable("{{compensation_value}}", language),
  "{{luggage_compensation_value}}": getDynamicVariable("{{luggage_compensation_value}}", language),
  "{{extra_expenses_compensation_value}}": getDynamicVariable("{{extra_expenses_compensation_value}}", language),
  "{{commission_value}}": getDynamicVariable("{{commission_value}}", language),
  "{{ah_price_value}}": getDynamicVariable("{{ah_price_value}}", language),
  "{{ec261_compensation}}": getDynamicVariable("{{ec261_compensation}}", language),
  "{{brazil_compensation}}": getDynamicVariable("{{brazil_compensation}}", language),
  "{{uk261_compensation}}": getDynamicVariable("{{uk261_compensation}}", language),
  "{{passengers_compensated}}": getDynamicVariable("{{passengers_compensated}}", language),
  "{{br_flight_delay}}": getDynamicVariable("{{br_flight_delay}}", language),
  "{{nr_airhelpers}}": getDynamicVariable("{{nr_airhelpers}}", language),
  "{{nr_languages}}": getDynamicVariable("{{nr_languages}}", language),
  "{{nr_ahp_purchases}}": getDynamicVariable("{{nr_ahp_purchases}}", language),
  "{{nr_flights_checked}}": getDynamicVariable("{{nr_flights_checked}}", language),
  "{{goodwill_price}}": getDynamicVariable("{{goodwill_price}}", language),
  "{{minimum_extra_expenses}}": getDynamicVariable("{{minimum_extra_expenses}}", language),
  "{{airpayout_payout}}": getDynamicVariable("{{airpayout_payout}}", language),
  "{{ah_essential_price}}": getDynamicVariable("{{ah_essential_price}}", language),
  "{{ah_from_price}}": getDynamicVariable("{{ah_from_price}}", language),
  "{{ah_complete_price}}": getDynamicVariable("{{ah_complete_price}}", language),
  "{{ah_essential_effective}}": getDynamicVariable("{{ah_essential_effective}}", language),
  "{{ah_complete_effective}}": getDynamicVariable("{{ah_complete_effective}}", language),
  "{{airluggage_payout}}": getDynamicVariable("{{airluggage_payout}}", language),
  "{{ahp_lounges}}": getDynamicVariable("{{ahp_lounges}}", language),
});

export const setVariables = (props: StoryblokTemplateProps, language: LanguageCode) => {
  const { story } = props;
  const replacers = getReplacers(language);
  const updatedContent = replaceAll(story, replacers);

  return { ...props, story: updatedContent } as StoryblokTemplateProps;
};
